import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { PageSection } from '../../../Layout';
import { WorksheetImagesAndRemarksSection, WorksheetTestedBySection } from '../../Core';
import { WorksheetRootComponent } from '../../Core/types';
import ids from '../../QestIds';
import { PortionPreparationPageSection, ResultsPageSection, SpecimenPreparationPageSection } from './Sections';
import HydrometerMeasurementsPageSection from './Sections/HydrometerMeasurementsPageSection';

const qestIds = [ids.hydrometer.BS_EN_ISO_17892_4_Clause_5_3.Rev2016];

const HydrometerBsEnIsoWorksheetBase: WorksheetRootComponent = () => {
  return (
    <>
      <SpecimenPreparationPageSection />
      <PortionPreparationPageSection />
      <HydrometerMeasurementsPageSection />

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>

      <ResultsPageSection />

      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

HydrometerBsEnIsoWorksheetBase.qestIds = qestIds;
const HydrometerBsEnIsoWorksheet = withInjectedProps(HydrometerBsEnIsoWorksheetBase);

export default HydrometerBsEnIsoWorksheet;
export { HydrometerBsEnIsoWorksheet as PsdHydrometerBsEnIsoWorksheet };
